const identityMeta = {
  teacher: {
    menu: [
      {
        name: '班级管理',
        icon: 'organization',
        to: 'classgradeManagement'
      },
      {
        name: '学生管理',
        icon: 'personnel',
        to: 'studentManagement'
      },
      {
        name: '资源管理',
        icon: 'resources',
        secondMenus: [
          {
            name: '资源管理 / 课件管理',
            title: '课件管理',
            subjects: true,
            to: 'teachingManagement'
          },
          {
            name: '资源管理 / 素材管理',
            title: '素材管理',
            subjects: true,
            to: 'sourceManagement'
          }
        ]
      },
      {
        name: '说课管理',
        icon: 'lecture',
        to: 'lectureManagement',
        subjects: true
      },
      {
        name: '教案管理',
        icon: 'lesson',
        to: 'lessonManagement',
        subjects: true
      },
      {
        name: '题库管理',
        icon: 'question',
        to: 'abilityList',
        subjects: true
      },
      {
        name: '谱例管理',
        icon: 'score',
        to: 'exampleManage'
      },
      {
        name: '作品结构管理',
        icon: 'Aid',
        to: 'musicalManagement'
      },
      {
        name: '跟(带)唱读管理',
        icon: 'sing',
        to: 'singAlongManagement'
      },
      {
        name: '教具管理',
        icon: 'Aid',
        to: 'teachingAidsList'
      },
      {
        name: '权益管理',
        icon: 'Equity',
        to: 'examActivityManagement'
      },
      {
        name: '测评管理',
        icon: 'test',
        secondMenus: [
          {
            name: '测评管理 / 题型赋分管理',
            title: '题型赋分管理',
            to: 'performanceValueManagement'
          }
        ] 
      }
    ]
  },
  school_admin: {
    menu: [
      {
        name: '班级管理',
        icon: 'organization',
        to: 'classgradeManagement'
      },
      {
        name: '人员管理',
        icon: 'personnel',
        secondMenus: [
          {
            name: '人员管理 / 教师管理',
            title: '教师管理',
            icon: 'chalkboard',
            to: 'teacherManagement'
          },
          {
            name: '人员管理 / 学生管理',
            title: '学生管理',
            icon: 'user-graduate',
            to: 'studentManagement'
          }
        ]
      },
      {
        name: '资源管理',
        icon: 'resources',
        secondMenus: [
          {
            name: '资源管理 / 课件管理',
            title: '课件管理',
            to: 'teachingManagement',
            subjects: true,
          },
          {
            name: '资源管理 / 素材管理',
            title: '素材管理',
            subjects: true,
            to: 'sourceManagement'
          }
        ]
      },
      {
        name: '说课管理',
        icon: 'lecture',
        to: 'lectureManagement',
        subjects: true
      },
      {
        name: '教案管理',
        icon: 'lesson',
        to: 'lessonManagement',
        subjects: true
      },
      {
        name: '谱例管理',
        icon: 'score',
        to: 'exampleManage'
      },

      {
        name: '题库管理',
        icon: 'question',
        subjects: true,
        to: 'abilityList'
      },
      {
        name: '作品结构管理',
        icon: 'Aid',
        to: 'musicalManagement'
      },
      {
        name: '跟(带)唱读管理',
        icon: 'sing',
        to: 'singAlongManagement'
      },
      {
        name: '权益管理',
        icon: 'Equity',
        to: 'examActivityManagement'
      }
    ]
  },

  platform_admin: {
    menu: [
      {
        name: '首页',
        icon: 'midihome2',
        to: 'workbenchMain',
      },
      {
        name: '组织管理',
        icon: 'organization',
        secondMenus: [
          {
            name: '组织管理 / 学校管理',
            title: '学校管理',
            icon: 'school',
            to: 'schoolManagement',
          },
          {
            name: '组织管理 / 班级管理',
            title: '班级管理',
            icon: 'users',
            to: 'classgradeManagement'
          }
        ]
      },
      {
        name: '人员管理',
        icon: 'personnel',
        secondMenus: [
          {
            name: '人员管理 / 校管管理',
            title: '校管管理',
            icon: 'user-tie',
            to: 'schoolAdminManagement'
          },
          {
            name: '人员管理 / 教师管理',
            title: '教师管理',
            icon: 'chalkboard',
            to: 'teacherManagement'
          },
          {
            name: '人员管理 / 学生管理',
            title: '学生管理',
            icon: 'user-graduate',
            to: 'studentManagement'
          },
          // 2024.01.02 10:28 书荣 start------
          // {
          //   name: '人员管理 / 教研管理',
          //   title: '教研管理',
          //   icon: 'user-graduate',
          //   to: 'researchManagement'
          // },
          // 2024.01.02 10:28 书荣 end-----

          // {
          // 	name: '人员管理 / 代理管理',
          // 	title: '代理管理',
          // 	icon: 'user-graduate',
          // 	to: 'agencyManagement'
          // }
        ]
      },
      {
        name: '资源管理',
        icon: 'resources',
        secondMenus: [
          {
            name: '资源管理 / 课件管理',
            title: '课件管理',
            to: 'teachingManagement',
            subjects: true
          },
          {
            name: '资源管理 / 素材管理',
            title: '素材管理',
            to: 'sourceManagement',
            subjects: true
          }
        ]
      },
      {
        name: '说课管理',
        icon: 'lecture',
        to: 'lectureManagement',
        subjects: true
      },
      {
        name: '教案管理',
        icon: 'lesson',
        to: 'lessonManagement',
        subjects: true
      },
      {
        name: '题库管理',
        icon: 'question',
        to: 'abilityList',
        subjects: true
      },
      {
        name: '谱例管理',
        icon: 'score',
        to: 'exampleManage'
      },
      {
        name: '作品结构管理',
        icon: 'Aid',
        to: 'musicalManagement'
      },
      {
        name: '跟(带)唱读管理',
        icon: 'sing',
        to: 'singAlongManagement'
      },
      {
        name: '权益管理',
        icon: 'Equity',
        to: 'examActivityManagement'
      },
      {
        name: '激活码管理',
        icon: 'key',
        to: 'keyManagement'
      },
      // {
      //   name: '应用管理',
      //   icon: 'Aid',
      //   to: 'appManagement'
      // },
      // {
      //   name: '应用管理',
      //   icon: 'Aid',
      //   to: 'basicSetting'
      // },
      {
        name: '权限管理',
        icon: 'authority',
        to: 'publicNoticeList'
      },
      {
        name: '日志管理',
        icon: 'authority',
        to: 'logManagement'
      },
      {
        name: '测评管理',
        icon: 'test',
        secondMenus: [
          {
            name: '测评管理 / 测评指标表',
            title: '测评指标表',
            to: 'testManagement'
          },
           {
            name: '测评管理 / 题型赋分管理',
            title: '题型赋分管理',
            to: 'performanceValueManagement'
          }
        ] 
      }
    ]
  },

  other: {
    menu: [
      {
        name: '首页',
        icon: 'midihome2',
        to: 'workbenchMain'
      },
      {
        name: '组织管理',
        icon: 'organization',
        secondMenus: [
          {
            name: '组织管理 / 学校管理',
            title: '学校管理',
            icon: 'school',
            to: 'schoolManagement'
          },
          {
            name: '组织管理 / 班级管理',
            title: '班级管理',
            icon: 'users',
            to: 'classgradeManagement'
          }
        ]
      },
      {
        name: '人员管理',
        icon: 'personnel',
        secondMenus: [
          {
            name: '人员管理 / 校管管理',
            title: '校管管理',
            icon: 'user-tie',
            to: 'schoolAdminManagement',
          },
          {
            name: '人员管理 / 教师管理',
            title: '教师管理',
            icon: 'chalkboard',
            to: 'teacherManagement'
          },
          {
            name: '人员管理 / 学生管理',
            title: '学生管理',
            icon: 'user-graduate',
            to: 'studentManagement'
          }
        ]
      },
      {
        name: '资源管理',
        icon: 'resources',
        secondMenus: [
          {
            name: '资源管理 / 课件管理',
            title: '课件管理',
            subjects: true,
            to: 'teachingManagement'
          },
          {
            name: '资源管理 / 素材管理',
            title: '素材管理',
            subjects: true,
            to: 'sourceManagement'
          }
        ]
      },
      {
        name: '说课管理',
        icon: 'lecture',
        to: 'lectureManagement',
        subjects: true
      },
      {
        name: '教案管理',
        icon: 'lesson',
        to: 'lessonManagement',
        subjects: true
      },
      {
        name: '题库管理',
        icon: 'question',
        to: 'abilityList',
        subjects: true
      },
      {
        name: '谱例管理',
        icon: 'score',
        to: 'exampleManage'
      },
      {
        name: '作品结构管理',
        icon: 'Aid',
        to: 'musicalManagement'
      },
      {
        name: '跟(带)唱读管理',
        icon: 'sing',
        to: 'singAlongManagement'
      },
      {
        name: '权益管理',
        icon: 'Equity',
        to: 'examActivityManagement'
      },
      {
        name: '激活码管理',
        icon: 'key',
        to: 'keyManagement'
      },
      {
        name: '测评管理',
        icon: 'test',
        secondMenus: [
          {
            name: '测评管理 / 测评指标表',
            title: '测评指标表',
            to: 'testManagement'
          },
           {
            name: '测评管理 / 题型赋分管理',
            title: '题型赋分管理',
            to: 'performanceValueManagement'
          }
        ]
      },
      {
        name: '权限管理',
        icon: 'authority',
        to: 'publicNoticeList'
      }
    ]
  },

  research: {
    menu: [
      {
        name: '资源管理',
        icon: 'resources',
        secondMenus: [
          {
            name: '资源管理 / 课件管理',
            title: '课件管理',
            to: 'teachingManagement',
            subjects: true,
          },
          {
            name: '资源管理 / 素材管理',
            title: '素材管理',
            subjects: true,
            to: 'sourceManagement'
          }
        ]
      },
      {
        name: '题库管理',
        icon: 'question',
        to: 'abilityList',
        subjects: true
      },
      {
        name: '谱例管理',
        icon: 'score',
        to: 'exampleManage'
      },
    ]
  }
}

export { identityMeta }
